"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Image = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  BREAKPOINTS
} = require('../../util/constants/breakpoints').default;

/**
 * Image component
 *
 * @method
 * @param {ImageProps} props
 * @returns Image
 */

const Image = props => {
  const {
    desktopImage,
    tabletImage,
    mobileImage,
    altText,
    ariaHidden,
    loading = defaultProps.loading
  } = props;
  if (!desktopImage) {
    return null;
  }
  const conditionalProps = (0, _conditionalAttributes.conditionalAttributes)({
    'aria-hidden': ariaHidden ? 'true' : undefined
  });

  /* Setting the tablet and desktop breakpoints
   * for the image source to be put into the srcSets
  */
  const tabletBreakdown = '(min-width: ' + BREAKPOINTS.MEDIUM + 'px)';
  const desktopBreakdown = '(min-width: ' + BREAKPOINTS.LARGE + 'px)';

  /* Setting the default image to the mobileImage,
  *  but if one isn't given then the default will be desktopImage
  */
  let defaultImage = mobileImage;
  if (!mobileImage) {
    defaultImage = desktopImage;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Image"
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: desktopImage,
    media: desktopBreakdown
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: tabletImage,
    media: tabletBreakdown
  }), /*#__PURE__*/_react.default.createElement("img", _extends({
    className: "pal-c-Image__img",
    src: defaultImage,
    alt: altText,
    loading: loading
  }, conditionalProps))));
};

/**
 * Property type definitions
 * @typedef ImageProps
 * @type {object}
 * @property {boolean} ariaHidden - aria-hidden property for image (ADA)
 * @property {string} desktopImage
 * @property {string} tabletImage
 * @property {string} mobileImage
 * @property {string} altText
 * @property {string} loading
 */
exports.Image = Image;
const propTypes = exports.propTypes = {
  /**
   * aria-hidden to be set for image (ADA)
   */
  ariaHidden: _propTypes.default.bool,
  /**
   * url src for the desktop image
   */
  desktopImage: _propTypes.default.string,
  /**
   * url src for the tablet image
   */
  tabletImage: _propTypes.default.string,
  /**
   * url src for the mobile image
   */
  mobileImage: _propTypes.default.string,
  /**
   * Image alt text
   */
  altText: _propTypes.default.string,
  /**
   * Loading state for the image (lazy is the default)
   * - **lazy:** Load the image lazy
   * - **eager:** Load the image as usual
   */
  loading: _propTypes.default.oneOf(['lazy', 'eager'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} loading='lazy' - set the default value of loading
 */
const defaultProps = exports.defaultProps = {
  loading: 'lazy'
};
Image.propTypes = propTypes;
var _default = exports.default = Image;